import { render } from "./HighlightedSection.vue?vue&type=template&id=78b9b3da"
import script from "./HighlightedSection.vue?vue&type=script&lang=js"
export * from "./HighlightedSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__